import React, { useEffect, useState } from "react";
import {
  Row,
  Image,
  Avatar,
  Layout,
  Space,
  Typography,
  Menu,
  Modal,
  Dropdown,
  Button,
  Card,
  Col,
  Input,
  message,
  Upload,
  Divider,
  Rate,
  Drawer,
  Badge,
  List,
} from "antd";
import "dayjs/locale/th";
import logoDashboardMed from "../Image/logoDashboardMed.png";
import { Header, Content } from "antd/lib/layout/layout";
import {
  LockOutlined,
  FileProtectOutlined,
  SafetyCertificateOutlined,
  LogoutOutlined,
  UserOutlined,
  AppstoreOutlined,
  FileOutlined,
  MenuOutlined,
  WarningOutlined,
  StarOutlined,
  InboxOutlined,
  CheckCircleTwoTone,
  BellOutlined,
  StarFilled,
  AppstoreFilled,
  FileAddFilled,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
} from "@ant-design/icons";
import R from "@routers/R";
import { CK_TOKEN_DASHBOARD_MED } from "@constant/constant";
import { Cookies, useCookies } from "react-cookie";
import { Redirect, useHistory, useRouteMatch } from "react-router-dom";
import { webapi, APIEndpointWeb } from "@client/web";
import ModalTermsOfUse from "@pages/AllModal/ModalCheckEkyc/ModalTermsOfUse/ModalTermsOfUse";
import ModalPolicy from "@pages/AllModal/ModalPolicy/ModalPolicy";
import NewPasswordLogin from "@pages/AllSetting/NewPasswordLogin";
import type { UploadProps } from "antd";
import { useLocation } from "react-router-dom";
import Sider from "antd/lib/layout/Sider";
const { Text } = Typography;
const { Dragger } = Upload;
const desc = ["แย่มาก", "ไม่ดี", "ปกติ", "ดี", "ยอดเยี่ยม"];
const dayjs = require("dayjs");
interface DataType {
  gender?: string;
  name: {
    title?: string;
    first?: string;
    last?: string;
  };
  email?: string;
  picture: {
    large?: string;
    medium?: string;
    thumbnail?: string;
  };
  nat?: string;
  loading: boolean;
}

const DashboardMedicalLayout: React.FC = (props): JSX.Element => {
  const history = useHistory();
  const [resDataUser, setResDataUser] = useState<any>();
  const [isModalTermsAndConditions, setIsModalTermsAndConditions] = useState(
    false
  );
  const [isModalOpenPolicy, setIsModalOpenPolicy] = useState(false);
  const [showModalResetPassword, setShowModalResetPassword] = useState(false);
  const [goToPath, setGoToPath] = useState("");
  const [WindowResize, setWindowResize] = useState(Number);
  const [showModalshowModalWarning, setShowModalshowModalWarning] = useState(
    false
  );
  let location = useLocation();
  const [showModalshowModalRate, setShowModalshowModalRate] = useState(false);
  const [defaultSelectedKeys, setdefaultSelectedKeys] = useState(["1"]);
  const [open, setOpen] = useState(false);
  const [cookies, setCookie, removeCookie] = useCookies([
    CK_TOKEN_DASHBOARD_MED,
  ]);
  const [valRatingscore1, setValRatingscore1] = useState<any>("");
  const [valRatingscore2, setValRatingscore2] = useState<any>("");
  const [valRatingscore3, setValRatingscore3] = useState<any>("");
  const [valRatingscore4, setValRatingscore4] = useState<any>("");
  const [valRatingComment, setValRatingComment] = useState<any>("");
  const [valScoreDashboard, setValScoreDashboard] = useState<any>("");
  const [valCommentDashboard, setValCommentDashboard] = useState<any>("");
  const [ticketdDescription, setTicketdDescription] = useState<any>("");
  const [ticketImage, setTicketImage] = useState<any>([]);
  const [openRight, setOpenRight] = useState(false);
  const [count, setCount] = useState<any>();
  const [medicNoti, setMedicNoti] = useState<any[]>([]);
  const [show, setShow] = useState(true);
  const [collapsed, setCollapsed] = useState(false);
  const onChangeShow = (checked: boolean) => {
    setShow(checked);
  };
  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };
  const showDrawerRight = () => {
    setOpenRight(true);
  };
  const onCloseRight = () => {
    setOpenRight(false);
  };
  useEffect(() => {
    // CountNotification();
    const interval = setInterval(() => {
      // MedicNotification();
      CountNotification();
    }, 5000);
    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    if (location.pathname === "/dashboard-medical") {
      setdefaultSelectedKeys(["1"]);
    } else if (location.pathname === "/manage-data") {
      setdefaultSelectedKeys(["2"]);
    }
  }, []);
  useEffect(() => {
    checkCookie();
  }, []);
  useEffect(() => {
    window.addEventListener("resize", handleWindowResize);
    handleWindowResize();
  }, [WindowResize]);
  const showDrawer = () => {
    setOpen(true);
  };
  const [openTop, setOpenTop] = useState(false);
  const showDrawerTop = () => {
    setOpenTop(true);
  };
  const onCloseTop = () => {
    // setHightOpenTop(false)
    setOpenTop(false);
  };
  const onClose = () => {
    setOpen(false);
  };
  const handleWindowResize = () => {
    setWindowResize(window.innerWidth);
  };
  const handleGoToPath = (path: string): void => {
    setGoToPath(path);
  };
  const showModal1 = () => {
    setIsModalTermsAndConditions(true);
  };
  const showModal2 = () => {
    setIsModalOpenPolicy(true);
  };
  const handleOk1 = () => {
    setIsModalTermsAndConditions(false);
  };
  const handleCancel1 = () => {
    setIsModalTermsAndConditions(false);
  };
  const handleOk2 = () => {
    setIsModalOpenPolicy(false);
  };

  const handleCancel2 = () => {
    setIsModalOpenPolicy(false);
  };
  const handleOk3 = () => {
    setShowModalResetPassword(false);
  };

  const handleCancel3 = () => {
    setShowModalResetPassword(false);
  };
  const showModal3 = () => {
    setShowModalResetPassword(true);
  };
  const showModalRate = () => {
    setShowModalshowModalRate(true);
  };
  const handleOkshowModalRate = () => {
    setShowModalshowModalRate(false);
  };

  const handleCancelRate = () => {
    setShowModalshowModalRate(false);
  };

  const handleCancelWarning = () => {
    setShowModalshowModalWarning(false);
  };
  const showModalWarning = () => {
    setShowModalshowModalWarning(true);
  };
  const { children } = props;

  const checkCookie = () => {
    webapi
      .get(`${APIEndpointWeb.checkCookie}`, {
        withCredentials: true,
      })
      .then(async () => {
        const { data } = await webapi.get(`${APIEndpointWeb.GetUserDisplay}`, {
          withCredentials: true,
        });
        setResDataUser(data.result);
      })
      .catch((error) => {
        console.log(error.response);
        if (error.response.status === 401) {
          // window.location.reload()
          history.push("/login-dashboard-medical");
        }
      });
  };
  const ratingscore = async (): Promise<any> => {
    const score = {
      score: [
        {
          topic: "ความง่าย ความสะดวก",
          score: `${valRatingscore1}`,
        },
        {
          topic: "ความพร้อมในการใช้งาน",
          score: `${valRatingscore2}`,
        },
        {
          topic: "ความน่าเชื่อถือของระบบ",
          score: `${valRatingscore3}`,
        },
        {
          topic: "การตอบสนองในการใช้งาน",
          score: `${valRatingscore4}`,
        },
      ],
      score_dashboard: [
        {
          topic:
            "การแสดงผลและการออกแบบ เข้าใจง่าย มีข้อมูลครบถ้วนจามที่ต้องการ",
          score: `${valScoreDashboard}`,
        },
      ],
      // score_dashboard: valScoreDashboard,
      comment_dashboard: valCommentDashboard,
      comment: valRatingComment,
    };
    try {
      const { data } = await webapi.post(
        `${APIEndpointWeb.ratingscore}`,
        score,
        {
          withCredentials: true,
        }
      );
    } catch (error) {
      if (error === "Unauthorized") {
        window.location.replace("/login");
      }
      // }
    }
  };
  const props1: UploadProps = {
    name: "file",
    multiple: true,
    action: "",
    onChange(info) {
      const { status } = info.file;
      if (status !== "uploading") {
        setTicketImage(info.fileList);
      }
      if (status === "done") {
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };
  const ticket = async (): Promise<any> => {
    const payload = {
      description: ticketdDescription,
      ticket_image: ticketImage,
    };
    try {
      const { data } = await webapi.post(`${APIEndpointWeb.ticket}`, payload, {
        withCredentials: true,
      });
    } catch (error) {
      if (error === "Unauthorized") {
        window.location.replace("/login");
      }
      // }
    }
  };
  const confirmticket = () => {
    Modal.confirm({
      title: "ยืนยันส่งข้อมูล",
      icon: <CheckCircleTwoTone twoToneColor="#52c41a" />,
      content: " ",
      okText: "ตกลง",
      onOk: (): void => {
        ticket();
        window.location.reload();
      },
      cancelText: "ยกเลิก",
      okButtonProps: { style: { background: "#147F8B", borderRadius: "5px" } },
      cancelButtonProps: {
        style: { background: "#B5B5B5", color: "white", borderRadius: "5px" },
      },
    });
  };
  const confirmratingscore = () => {
    Modal.confirm({
      title: "ยืนยันส่งข้อมูล",
      icon: <CheckCircleTwoTone twoToneColor="#52c41a" />,
      content: " ",
      okText: "ตกลง",
      onOk: (): void => {
        ratingscore();
        window.location.reload();
      },
      cancelText: "ยกเลิก",
      okButtonProps: { style: { background: "#147F8B", borderRadius: "5px" } },
      cancelButtonProps: {
        style: { background: "#B5B5B5", color: "white", borderRadius: "5px" },
      },
    });
  };

  const showConfirm = (): any => {
    Modal.confirm({
      title: "คุณต้องการออกจากระบบใช่หรือไม่",
      // content: 'ลงชื่อออก',
      okText: "ตกลง",
      cancelText: "ยกเลิก",
      okButtonProps: {
        type: "primary",
      },
      cancelButtonProps: {
        type: "default",
      },
      onOk() {
        setTimeout(() => {
          handleMenuClick();
        }, 1000);
      },
      onCancel() {
        // console.log('can');
      },
    });
  };
  const handleMenuClick = (): any => {
    webapi
      .post(`${APIEndpointWeb.logout}`, {
        withCredentials: true,
      })
      .then(() => {})
      .catch((error) => {
        console.log(error.response);
      });
    history.replace("/login-dashboard-medical");
  };
  const checkpathname = () => {
    switch (window.location.pathname) {
      case "/dashboard-medical":
        return "dashboard";
      case "/manage-data":
        return "จัดการคำร้อง";
      default:
        return "dashboard";
    }
  };

  const MenuMed = (): JSX.Element => {
    return (
      <Row className="test222">
        <Row
          className="pb-2 test333"
          style={{
            width: "100%",
          }}
        >
          <Col
            className="pl-2 pr-2"
            xs={24}
            sm={24}
            md={24}
            lg={24}
            xl={24}
            xxl={24}
          >
            <Card
              style={{
                backgroundColor: "#26334A",
                borderRadius: "20px 20px 0px 0px",
              }}
            >
              <Row style={{ textAlign: "center" }}>
                <Col xs={6} sm={6} md={6} lg={6} xl={6} xxl={6}>
                  <Avatar size="large" icon={<UserOutlined />} />
                </Col>
                <Col
                  xs={18}
                  sm={18}
                  md={18}
                  lg={18}
                  xl={18}
                  xxl={18}
                  className="mt-2"
                >
                  <Text style={{ color: "#ffffff", fontSize: "16px" }}>
                    {/* {resUserDisplay?.name} */}
                    {resDataUser?.name}
                  </Text>
                </Col>
              </Row>
            </Card>
            <Row>
              <Col
                className="pl-2 pr-2"
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={24}
                xxl={24}
                style={{
                  backgroundColor: "#26334A",
                  borderRadius: "0px 0px 20px 20px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Text
                  className="mt-2 mb-2"
                  style={{ color: "#ffffff", fontSize: "14px" }}
                >
                  {resDataUser?.hospital_name}
                </Text>
              </Col>
            </Row>

            <Row className="pt-2 pb-2" style={{ backgroundColor: "#B6D3D6" }}>
              <Menu mode="inline" style={{ backgroundColor: "#B6D3D6 " }}>
                <Menu.Item
                  key="1"
                  onClick={showModalRate}
                  style={{ border: "0px solid #B6D3D6", borderRadius: "10px" }}
                >
                  <StarOutlined
                    style={{
                      fontSize: "20px",
                      color: "#26334A",
                    }}
                  />
                  <Text>แบบประเมินความพึงพอใจ</Text>
                </Menu.Item>
                <Menu.Item
                  key="2"
                  onClick={showModalWarning}
                  style={{ border: "0px solid #B6D3D6", borderRadius: "10px" }}
                >
                  <WarningOutlined
                    style={{
                      fontSize: "20px",
                      color: "#26334A",
                    }}
                  />
                  <Text>แจ้งปัญหาและข้อเสนอแนะ</Text>
                </Menu.Item>
                <Menu.Item
                  key="3"
                  onClick={showModal3}
                  style={{ border: "0px solid #B6D3D6", borderRadius: "10px" }}
                >
                  <LockOutlined
                    style={{ fontSize: "20px", color: "#26334A" }}
                  />
                  <Text>เปลี่ยนรหัสผ่าน</Text>
                </Menu.Item>
                <Menu.Item
                  key="4"
                  onClick={showModal1}
                  style={{ border: "0px solid #B6D3D6", borderRadius: "10px" }}
                >
                  <FileProtectOutlined
                    style={{ fontSize: "20px", color: "#26334A" }}
                  />
                  <Text>ข้อกำหนดการใช้งาน</Text>
                </Menu.Item>
                <Menu.Item
                  key="5"
                  onClick={showModal2}
                  style={{ border: "0px solid #B6D3D6", borderRadius: "10px" }}
                >
                  <SafetyCertificateOutlined
                    style={{ fontSize: "20px", color: "#26334A" }}
                  />
                  <Text>นโยบายคุ้มครองข้อมูลส่วนบุคคล</Text>
                </Menu.Item>
                <Menu.Item
                  key="6"
                  onClick={showConfirm}
                  style={{ border: "0px solid #B6D3D6", borderRadius: "10px" }}
                >
                  <LogoutOutlined
                    style={{ fontSize: "20px", color: "#26334A" }}
                  />
                  <Text> ออกจากระบบ </Text>
                </Menu.Item>
              </Menu>
            </Row>
            <Modal
              title="ข้อกำหนดการใช้งาน FMR"
              // width='540px'
              // className="modal-left"
              visible={isModalTermsAndConditions}
              onOk={handleOk1}
              onCancel={handleCancel1}
              footer={
                <Button type="primary" size="middle" onClick={handleCancel1}>
                  ปิด
                </Button>
              }
            >
              <ModalTermsOfUse />
            </Modal>
            <Modal
              title="นโยบายคุ้มครองข้อมูลส่วนบุคคล"
              visible={isModalOpenPolicy}
              onOk={handleOk2}
              onCancel={handleCancel2}
              footer={
                <Button type="primary" size="middle" onClick={handleCancel2}>
                  ปิด
                </Button>
              }
            >
              <ModalPolicy />
            </Modal>
            <Modal
              className="modal-left"
              width="540px"
              title="แบบประเมินความพึงพอใจ"
              visible={showModalshowModalRate}
              onCancel={handleCancelRate}
              footer={
                <div>
                  <Row justify="center" className="pt-2 pb-2" gutter={[16, 8]}>
                    <>
                      <Button
                        type="ghost"
                        style={{
                          borderRadius: "10px",
                          height: "5vh",
                          width: "30%",
                        }}
                        onClick={handleCancelRate}
                      >
                        ยกเลิก
                      </Button>
                      <Button
                        onClick={confirmratingscore}
                        disabled={
                          valRatingscore1 === "" ||
                          valRatingscore2 === "" ||
                          valRatingscore3 === "" ||
                          valRatingscore4 === "" ||
                          valRatingComment === "" ||
                          valCommentDashboard === "" ||
                          valScoreDashboard === ""
                        }
                        type="primary"
                        style={{
                          borderRadius: "10px",
                          height: "5vh",
                          width: "30%",
                        }}
                      >
                        ส่ง
                      </Button>
                    </>
                  </Row>
                </div>
              }
            >
              <Col
                className="mr-4 ml-4 mt-2 mb-2"
                style={{ overflowY: "scroll", height: 380 }}
              >
                <Row>
                  <Text style={{ fontSize: "14px", fontWeight: "bold" }}>
                    1. ความพึงพอใจของระบบ
                  </Text>
                  <Divider style={{ marginTop: "15px", marginBottom: "3px" }} />
                </Row>
                <Row>
                  <Col
                    xs={14}
                    sm={14}
                    md={14}
                    lg={14}
                    xl={14}
                    xxl={14}
                    className="mt-1"
                  >
                    <Text style={{ wordBreak: "break-all", width: "100%" }}>
                      {" "}
                      1.1 ความง่ายความสะดวก{" "}
                    </Text>
                  </Col>
                  <Col xs={10} sm={10} md={10} lg={10} xl={10} xxl={10}>
                    <span>
                      <Rate
                        tooltips={desc}
                        onChange={setValRatingscore1}
                        value={valRatingscore1}
                      />
                    </span>
                  </Col>
                </Row>
                <Divider style={{ marginTop: "3px", marginBottom: "3px" }} />
                <Row>
                  <Col
                    xs={14}
                    sm={14}
                    md={14}
                    lg={14}
                    xl={14}
                    xxl={14}
                    className="mt-1"
                  >
                    <Text> 1.2 ความพร้อมในการใช้งาน </Text>
                  </Col>
                  <Col xs={10} sm={10} md={10} lg={10} xl={10} xxl={10}>
                    <span>
                      <Rate
                        tooltips={desc}
                        onChange={setValRatingscore2}
                        value={valRatingscore2}
                      />
                    </span>
                  </Col>
                </Row>
                <Divider style={{ marginTop: "3px", marginBottom: "3px" }} />
                <Row>
                  <Col
                    xs={14}
                    sm={14}
                    md={14}
                    lg={14}
                    xl={14}
                    xxl={14}
                    className="mt-1"
                  >
                    <Text> 1.3 ความน่าเชื่อถือของระบบ</Text>
                  </Col>
                  <Col xs={10} sm={10} md={10} lg={10} xl={10} xxl={10}>
                    <span>
                      <Rate
                        tooltips={desc}
                        onChange={setValRatingscore3}
                        value={valRatingscore3}
                      />
                    </span>
                  </Col>
                </Row>
                <Divider style={{ marginTop: "3px", marginBottom: "3px" }} />
                <Row>
                  <Col
                    xs={14}
                    sm={14}
                    md={14}
                    lg={14}
                    xl={14}
                    xxl={14}
                    className="mt-1"
                  >
                    <Text> 1.4 การตอบสนองในการใช้งาน </Text>
                  </Col>
                  <Col xs={10} sm={10} md={10} lg={10} xl={10} xxl={10}>
                    <span>
                      <Rate
                        tooltips={desc}
                        onChange={setValRatingscore4}
                        value={valRatingscore4}
                      />
                    </span>
                  </Col>
                </Row>
                <Divider style={{ marginTop: "3px", marginBottom: "3px" }} />
                {/* <Row>
                <Text style={{ fontSize: "14px", fontWeight: "bold", marginTop: "15px" }}>
                  ข้อเสนอแนะ
                </Text>
              </Row> */}
                <Row className="mt-3">
                  <Input.TextArea
                    value={valRatingComment}
                    onChange={(e) => {
                      setValRatingComment(e.target.value);
                    }}
                    placeholder="ข้อเสนอแนะความพึงพอใจของระบบ"
                    style={{ width: "100%", borderRadius: "8px" }}
                    rows={3}
                  />
                </Row>
                <Row>
                  <Text
                    style={{
                      fontSize: "14px",
                      fontWeight: "bold",
                      marginTop: "15px",
                    }}
                  >
                    2. ความพึงพอใจของ Dashboard
                  </Text>
                  <Divider style={{ marginTop: "15px", marginBottom: "3px" }} />
                </Row>
                <Row>
                  <Col
                    xs={14}
                    sm={14}
                    md={14}
                    lg={14}
                    xl={14}
                    xxl={14}
                    className="mt-1"
                  >
                    <Text>
                      {" "}
                      2.1 การแสดงผลและการออกแบบ เข้าใจง่าย
                      มีข้อมูลครบถ้วนจามที่ต้องการ{" "}
                    </Text>
                  </Col>
                  <Col xs={10} sm={10} md={10} lg={10} xl={10} xxl={10}>
                    <span>
                      <Rate
                        tooltips={desc}
                        onChange={setValScoreDashboard}
                        value={valScoreDashboard}
                      />
                    </span>
                  </Col>
                </Row>
                <Divider style={{ marginTop: "15px", marginBottom: "3px" }} />
                <Row className="mt-3">
                  <Input.TextArea
                    value={valCommentDashboard}
                    onChange={(e) => {
                      setValCommentDashboard(e.target.value);
                    }}
                    placeholder="ข้อเสนอแนะความพึงพอใจของ Dashboard
                  "
                    style={{ width: "100%", borderRadius: "8px" }}
                    rows={3}
                  />
                </Row>

                {/* <Row>
                <Text style={{ fontSize: "14px", fontWeight: "bold" }}>
                  ข้อเสนอแนะ
                </Text>
              </Row> */}
              </Col>
            </Modal>

            <Modal
              className="modal-left"
              width="540px"
              title="แจ้งปัญหาและข้อเสนอแนะ"
              visible={showModalshowModalWarning}
              onCancel={handleCancelWarning}
              footer={
                <div>
                  <Row justify="center" className="pt-2 pb-2" gutter={[16, 8]}>
                    <>
                      <Button
                        type="ghost"
                        style={{
                          borderRadius: "10px",
                          height: "5vh",
                          width: "30%",
                        }}
                        onClick={handleCancelWarning}
                      >
                        ยกเลิก
                      </Button>
                      <Button
                        onClick={confirmticket}
                        disabled={
                          ticketdDescription === "" || ticketImage.length < 1
                        }
                        type="primary"
                        style={{
                          borderRadius: "10px",
                          height: "5vh",
                          width: "30%",
                        }}
                      >
                        ส่ง
                      </Button>
                    </>
                  </Row>
                </div>
              }
            >
              <div
                style={{
                  maxHeight: 450,
                  overflowX: "hidden",
                  padding: "5px",
                }}
              >
                <Row>
                  <Text style={{ fontWeight: "bold" }}>เพิ่มข้อความ :</Text>
                </Row>
                <Input.TextArea
                  value={ticketdDescription}
                  onChange={(e) => {
                    setTicketdDescription(e.target.value);
                  }}
                  className="mt-2"
                  placeholder="ระบุปัญหาที่ต้องการแจ้ง..."
                  style={{
                    width: "100%",
                    borderRadius: "8px",
                    touchAction: "manipulation",
                  }}
                  rows={5}
                />
                <Row className="mt-4 ml-2">
                  <Text style={{ fontWeight: "bold" }}>เพิ่มรูปภาพ :</Text>
                </Row>
                <Dragger
                  {...props1}
                  className="mt-2"
                  multiple={true}
                  maxCount={5}
                  accept="image/*"
                  action={""}
                  beforeUpload={() => false}
                  // fileList={nameFilePDFIDCard}
                  listType="picture"
                >
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">เพิ่มรูปภาพของคุณ</p>
                </Dragger>
              </div>
            </Modal>
            <Modal
              width="540px"
              // className="modal-left"
              visible={showModalResetPassword}
              onOk={handleOk3}
              onCancel={handleCancel3}
              footer={null}
            >
              <NewPasswordLogin />
            </Modal>
          </Col>
        </Row>
      </Row>
    );
  };
  const MedicNotification = async () => {
    try {
      const { data } = await webapi.get(`${APIEndpointWeb.MedicNotification}`, {
        withCredentials: true,
      });
      setMedicNoti(data.result);
      setCount(0);
    } catch (error) {
      // window.location.replace('/login')
    }
  };

  const CountNotification = async () => {
    try {
      const { data } = await webapi.get(`${APIEndpointWeb.CountNotification}`, {
        withCredentials: true,
      });
      setCount(data.result);
    } catch (error) {
      // window.location.replace('/login')
    }
  };
  // const handleBadgeClick = () => {
  //     setCount(0)
  // }
  const menu = (
    // setCount(0),
    <Col
      style={{
        width: "430px",
        right: "0px",
        height: "70vh",
        border: "1px solid rgba(140, 140, 140, 0.35)",
        overflowX: "hidden",
        position: "relative",
      }}
      className="p-4"
    >
      <Text style={{ fontSize: "21px", fontWeight: "bold" }}></Text>
      <List
        itemLayout="horizontal"
        dataSource={medicNoti}
        renderItem={(item) => (
          <List.Item>
            <List.Item.Meta
              avatar={
                <Avatar
                  style={{ backgroundColor: "#f8932d" }}
                  size="large"
                  icon={<StarFilled />}
                />
              }
              title={
                <a
                  href={`${process.env.REACT_APP_BACKEND}/manage-data`}
                  style={{ fontSize: "17px", fontWeight: 600 }}
                >
                  {item.insurance}
                </a>
              }
              description={
                <>
                  <Text strong style={{ color: "black", fontSize: "14px" }}>
                    เลขที่เอกสารอ้างอิง :{" "}
                  </Text>
                  <Text>{item.notification_id}</Text>
                  <br />
                  <Text style={{ color: "#3978d4", fontSize: "16px" }}>
                    {dayjs(item.created_at)
                      .locale("th")
                      .format("DD MMMM YYYY เวลา HH:mm น.")}
                  </Text>
                </>
              }
            />
          </List.Item>
        )}
      />
    </Col>
  );
  return (
    <Layout>
      {goToPath ? <Redirect to={goToPath} /> : null}
      <>
        <Row
          style={{
            minHeight: "100vh",
            display: "flex",
            flexFlow: "nowrap",
          }}
        >
          {WindowResize >= 1440 && (
            <>
              <Sider
                collapsed={collapsed}
                collapsible
                style={{
                  backgroundColor: "#fff",
                  boxShadow: "-5px 10px 10px 1px rgba(0, 0, 0, 0.25) ",
                }}
                width={250}
              >
                <Row>
                  <Col
                    className="pt-4 pr-3 pl-3 pb-5"
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    xxl={24}
                  >
                    <Space
                      direction="vertical"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <div
                        className={collapsed === false ? "ml-4" : "box-center"}
                      >
                        <Image
                          preview={false}
                          src={
                            collapsed === true
                              ? logoDashboardMed
                              : logoDashboardMed
                          }
                          width={collapsed === false ? "80%" : "60px"}
                        />
                      </div>
                    </Space>
                  </Col>
                </Row>
                <Row>
                  <Text
                    style={{ fontSize: "12px", color: "#808080" }}
                    className="ml-3"
                  >
                    MENU
                  </Text>
                  <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                    {window.location.pathname === "/dashboard-medical" ? (
                      <Button
                        onClick={(): void => {
                          history.push("/dashboard-medical");
                        }}
                        style={{
                          textAlign: "left",
                          backgroundColor: "#deeff0",
                          border: "none",
                          height: "48px",
                          fontSize: "18px",
                          width: "-webkit-fill-available",
                          boxShadow: "none",
                          borderRadius: "0px",
                          padding: "10px 15px",
                        }}
                      >
                        <Text style={{ color: "#119f99", fontSize: "18px" }}>
                          <AppstoreFilled style={{ marginRight: "10px" }} />
                          {collapsed === false ? <>Dashboard</> : ""}
                        </Text>
                      </Button>
                    ) : (
                      <Button
                        onClick={(): void => {
                          handleGoToPath(R.HomeRouter.dashboardMedical.link);
                        }}
                        style={{
                          textAlign: "left",
                          backgroundColor: "#fff",
                          border: "none",
                          height: "48px",
                          fontSize: "18px",
                          width: "-webkit-fill-available",
                          boxShadow: "none",
                          borderRadius: "0px",
                          padding: "10px 15px",
                        }}
                      >
                        <Text style={{ color: "#808080", fontSize: "18px" }}>
                          <AppstoreFilled style={{ marginRight: "10px" }} />
                          {collapsed === false ? <>Dashboard</> : ""}
                        </Text>
                      </Button>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col
                    className="mt-3"
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    xxl={24}
                  >
                    {window.location.pathname === "/manage-data" ? (
                      <Button
                        onClick={(): void => {
                          history.push("/manage-data");
                        }}
                        style={{
                          textAlign: "left",
                          backgroundColor: "#deeff0",
                          border: "none",
                          height: "48px",
                          fontSize: "18px",
                          width: "-webkit-fill-available",
                          boxShadow: "none",
                          borderRadius: "0px",
                          padding: "10px 15px",
                        }}
                      >
                        <Text style={{ color: "#119f99", fontSize: "18px" }}>
                          <FileOutlined
                            style={{
                              marginRight: "10px",
                              fontWeight: "bold",
                            }}
                          />
                          {collapsed === false ? <>จัดการคำร้อง</> : ""}
                        </Text>
                      </Button>
                    ) : (
                      <Button
                        onClick={(): void => {
                          handleGoToPath(R.HomeRouter.manageData.link);
                        }}
                        style={{
                          textAlign: "left",
                          backgroundColor: "#fff",
                          border: "none",
                          height: "48px",
                          fontSize: "18px",
                          width: "-webkit-fill-available",
                          boxShadow: "none",
                          borderRadius: "0px",
                          padding: "10px 15px",
                        }}
                      >
                        <Text style={{ color: "#808080", fontSize: "18px" }}>
                          <FileOutlined
                            style={{
                              marginRight: "10px",
                              fontWeight: "bold",
                            }}
                          />
                          {collapsed === false ? <>จัดการคำร้อง</> : ""}
                        </Text>
                      </Button>
                    )}
                  </Col>
                </Row>
              </Sider>
              <Layout>
                <Header
                  style={{
                    boxShadow: "6px -5px 10px 1px rgba(0, 0, 0, 0.25 ",
                    zIndex: 1000,
                    top: 0,
                    left: 280,
                    right: 0,
                  }}
                >
                  <Row justify="space-between">
                    <Col
                      xs={12}
                      md={12}
                      lg={12}
                      xl={12}
                      xxl={12}
                      style={{ marginTop: "23px" }}
                    >
                      <Button type="text" onClick={toggleCollapsed}>
                        {collapsed ? (
                          <MenuUnfoldOutlined />
                        ) : (
                          <MenuFoldOutlined />
                        )}
                      </Button>
                      <Text style={{ fontSize: "16px" }}>
                        {checkpathname()}
                      </Text>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
                      <div className="layoutHeader">
                        <Space size={25}>
                          <Space
                            direction="vertical"
                            className="space-gap"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            {resDataUser ? (
                              <>
                                <Text className="textHeader">
                                  {resDataUser.hospital_name}
                                </Text>
                                <Text
                                  className="font-description"
                                  style={{ color: "#FE633C" }}
                                >
                                  {resDataUser.name}
                                </Text>
                              </>
                            ) : (
                              ""
                            )}
                          </Space>
                          <Badge
                            count={count}
                            style={{ backgroundColor: "red" }}
                          >
                            <div
                              onClick={MedicNotification}
                              style={{ position: "relative" }}
                            >
                              <Dropdown
                                overlay={menu}
                                overlayStyle={{
                                  paddingTop: "25px",
                                  zIndex: 0,
                                }}
                                trigger={["click"]}
                              >
                                <Avatar
                                  style={{ cursor: "pointer" }}
                                  size="large"
                                  icon={<BellOutlined />}
                                />
                              </Dropdown>
                            </div>
                          </Badge>
                          <Text style={{ color: " #147F8B", fontSize: "28px" }}>
                            {" "}
                            |{" "}
                          </Text>
                          <>
                            <Button
                              size="large"
                              style={{ cursor: "pointer" }}
                              shape="circle"
                              icon={<UserOutlined />}
                              onClick={showDrawerRight}
                            />
                            <Drawer
                              className="drawer-medical"
                              width={265}
                              placement="right"
                              onClose={onCloseRight}
                              visible={openRight}
                            >
                              {MenuMed()}
                            </Drawer>
                          </>
                        </Space>
                      </div>
                    </Col>
                  </Row>
                </Header>
                <Content
                  style={{
                    minHeight: "100vh",
                    backgroundColor: "rgb(245, 249, 255)",
                  }}
                >
                  {children}
                </Content>
              </Layout>
            </>
          )}

          {WindowResize <= 1439 && (
            <Layout>
              <Drawer
              placement="left" onClose={onClose} visible={open}
                style={{
                  boxShadow: "-5px 10px 10px 1px rgba(0, 0, 0, 0.25) ",
                  position: 'absolute',
                  zIndex: 9999,
                  height: '-webkit-fill-available'
                }}
                width={300}
              >
                <Row>
                  <Col
                    className="pt-4 pr-3 pl-3 pb-5"
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    xxl={24}
                  >
                    <Space
                      direction="vertical"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <div
                      >
                        <Image
                          preview={false}
                          src={
                            collapsed === true
                              ? logoDashboardMed
                              : logoDashboardMed
                          }
                          width={100}
                        />
                      </div>
                    </Space>
                  </Col>
                </Row>
                <Row>
                  <Text
                    style={{ fontSize: "12px", color: "#808080" }}
                    className="ml-3"
                  >
                    MENU
                  </Text>
                  <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                    {window.location.pathname === "/dashboard-medical" ? (
                      <Button
                        onClick={(): void => {
                          history.push("/dashboard-medical");
                        }}
                        style={{
                          textAlign: "left",
                          backgroundColor: "#deeff0",
                          border: "none",
                          height: "48px",
                          fontSize: "18px",
                          width: "-webkit-fill-available",
                          boxShadow: "none",
                          borderRadius: "0px",
                          padding: "10px 15px",
                        }}
                      >
                        <Text style={{ color: "#119f99", fontSize: "18px" }}>
                          <AppstoreFilled style={{ marginRight: "10px" }} />
                         Dashboard
                        </Text>
                      </Button>
                    ) : (
                      <Button
                        onClick={(): void => {
                          handleGoToPath(R.HomeRouter.dashboardMedical.link);
                        }}
                        style={{
                          textAlign: "left",
                          backgroundColor: "#fff",
                          border: "none",
                          height: "48px",
                          fontSize: "18px",
                          width: "-webkit-fill-available",
                          boxShadow: "none",
                          borderRadius: "0px",
                          padding: "10px 15px",
                        }}
                      >
                        <Text style={{ color: "#808080", fontSize: "18px" }}>
                          <AppstoreFilled style={{ marginRight: "10px" }} />
                          Dashboard
                        </Text>
                      </Button>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col
                    className="mt-3"
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    xxl={24}
                  >
                    {window.location.pathname === "/manage-data" ? (
                      <Button
                        onClick={(): void => {
                          history.push("/manage-data");
                        }}
                        style={{
                          textAlign: "left",
                          backgroundColor: "#deeff0",
                          border: "none",
                          height: "48px",
                          fontSize: "18px",
                          width: "-webkit-fill-available",
                          boxShadow: "none",
                          borderRadius: "0px",
                          padding: "10px 15px",
                        }}
                      >
                        <Text style={{ color: "#119f99", fontSize: "18px" }}>
                          <FileOutlined
                            style={{
                              marginRight: "10px",
                              fontWeight: "bold",
                            }}
                          />
                       จัดการคำร้อง
                        </Text>
                      </Button>
                    ) : (
                      <Button
                        onClick={(): void => {
                          handleGoToPath(R.HomeRouter.manageData.link);
                        }}
                        style={{
                          textAlign: "left",
                          backgroundColor: "#fff",
                          border: "none",
                          height: "48px",
                          fontSize: "18px",
                          width: "-webkit-fill-available",
                          boxShadow: "none",
                          borderRadius: "0px",
                          padding: "10px 15px",
                        }}
                      >
                        <Text style={{ color: "#808080", fontSize: "18px" }}>
                          <FileOutlined
                            style={{
                              marginRight: "10px",
                              fontWeight: "bold",
                            }}
                          />
                        จัดการคำร้อง
                        </Text>
                      </Button>
                    )}
                  </Col>
                </Row>
              </Drawer>
              {/* ) : ''} */}
              <Header
                style={{
                  boxShadow: "6px -5px 10px 1px rgba(0, 0, 0, 0.25 ",
                  zIndex: 1000,
                  top: 0,
                  left: 280,
                  right: 0,
                }}
              >
                <Row justify="space-between">
                  <Col
                    xs={12}
                    md={12}
                    lg={12}
                    style={{ marginTop: "23px" }}
                  >
                    <Button type="text" onClick={showDrawer}>
                      {collapsed ? (
                        <MenuUnfoldOutlined />
                      ) : (
                        <MenuFoldOutlined />
                      )}
                    </Button>
                    <Text style={{ fontSize: "16px" }}>{checkpathname()}</Text>
                  </Col>
                  <Col xs={12} md={12} lg={12} >
                    <div className="layoutHeader">
                      <Space size={25}>
                        <Space
                          direction="vertical"
                          className="space-gap"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {resDataUser && WindowResize > 627 ? (
                            <>
                              <Text className="textHeader-med">
                                {resDataUser.hospital_name}
                              </Text>
                              <Text
                                className="font-description-med"
                                style={{ color: "#FE633C" }}
                              >
                                {resDataUser.name}
                              </Text>
                            </>
                          ) : (
                            ""
                          )}
                        </Space>
                        <Badge count={count} style={{ backgroundColor: "red" }}>
                          <div
                            onClick={MedicNotification}
                            style={{ position: "relative" }}
                          >
                            <Dropdown
                              overlay={menu}
                              overlayStyle={{
                                paddingTop: "25px",
                                zIndex: 0,
                              }}
                              trigger={["click"]}
                            >
                              <Avatar
                                style={{ cursor: "pointer" }}
                                size="large"
                                icon={<BellOutlined />}
                              />
                            </Dropdown>
                          </div>
                        </Badge>
                        <Text style={{ color: " #147F8B", fontSize: "28px" }}>
                          {" "}
                          |{" "}
                        </Text>
                        <>
                          <Button
                            size="large"
                            style={{ cursor: "pointer" }}
                            shape="circle"
                            icon={<UserOutlined />}
                            onClick={showDrawerRight}
                          />
                          <Drawer
                            className="drawer-medical"
                            width={265}
                            placement="right"
                            onClose={onCloseRight}
                            visible={openRight}
                          >
                            {MenuMed()}
                          </Drawer>
                        </>
                      </Space>
                    </div>
                  </Col>
                </Row>
              </Header>
              <Content
                style={{
                  minHeight: "100vh",
                  backgroundColor: "rgb(245, 249, 255)",
                }}
              >
                {children}
              </Content>
            </Layout>
          )}
        </Row>
      </>
    </Layout>
  );
};

export default DashboardMedicalLayout;
